import { MUIDataTableColumn, MUIDataTableMeta } from 'mui-datatables';
import { Typography } from '@mui/material';
import { ERQUARD_COMPANY_KEY } from './helpers';
import { PATHS } from 'src/appConfig/paths';
import dayjs from 'dayjs';
import { Chip, Link } from 'src/components/common';
import { Navigator } from 'src/services';
import { stringify } from 'src/utils';

export const allColumns = (): MUIDataTableColumn[] => [
  {
    name: ERQUARD_COMPANY_KEY.COMPANY_NAME,
    label: 'Company Name',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (
        value: any,
        meta: MUIDataTableMeta | (Omit<MUIDataTableMeta, 'tableData'> & { tableData: any[] })
      ) => {
        const rowData = meta.tableData[meta.rowIndex] as any;
        const queryString = stringify({ uuid: rowData.id });
        const handleClick = (e) => {
          e.preventDefault();
          Navigator.navigate(`${PATHS.erGuard}${PATHS.companyManagement}?${queryString}`);
        };
        return (
          <Link
            href={`${PATHS.erGuard}${PATHS.companyManagement}?${queryString}`}
            onClick={handleClick}
          >
            <Typography sx={{ fontSize: 14, color: '#4684E7' }} variant="body2">
              {value ?? '--'}
            </Typography>
          </Link>
        );
      },
    },
  },
  {
    name: ERQUARD_COMPANY_KEY.EMAIL,
    label: 'Email',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: any, meta: MUIDataTableMeta) => {
        return <div className={'body__medium'}>{value ?? ''}</div>;
      },
    },
  },
  {
    name: ERQUARD_COMPANY_KEY.STATUS,
    label: 'Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: any, meta: MUIDataTableMeta) => {
        return <Chip typeOfChip={value} />;
      },
    },
  },
  {
    name: ERQUARD_COMPANY_KEY.CREATED_DATE,
    label: 'Created Date',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: any, meta: MUIDataTableMeta) => {
        const rowData = meta.tableData[meta.rowIndex] as any;
        return (
          <div className={'body__medium'}>{value ? dayjs(value).format('MM/DD/YYYY') : '--'}</div>
        );
      },
    },
  },
];
